import {
	DefRenderCell,
	DiscountRenderCell,
	largeFont,
	normalFont,
	QtyWithContribution,
	TableInLakhsDisplay,
} from "./gridCells";

export const buildCategoryColumns = (ltlCount, newCount) => [
	{
		field: "category",
		flex: 1.2,
		minWidth: 120,
		headerAlign: "center",
		headerName: "Category",
		renderCell: ({ row }) => <DefRenderCell value={row.category} row={row} font={normalFont} />,
	},
	{
		field: "ltl_qty",
		headerName: "PRV QTY",
		flex: 1,
		minWidth: 100,
		headerAlign: "center",
		renderCell: ({ row }) => (
			<QtyWithContribution value={row.ltl_qty} row={row} type="OLD" totalQty={ltlCount} />
		),
	},
	{
		field: "new_qty",
		headerName: "NEW QTY",
		flex: 1,
		minWidth: 100,
		headerAlign: "center",
		renderCell: ({ row }) => (
			<QtyWithContribution value={row.new_qty} row={row} type="NEW" totalQty={newCount} />
		),
	},
	{
		field: "ltl_dis",
		headerName: "PRV DIS",
		headerAlign: "center",
		flex: 0.8,
		minWidth: 80,
		renderCell: ({ row }) => <DiscountRenderCell type="OLD" row={row} value={row.ltl_dis} />,
	},
	{
		field: "new_dis",
		headerName: "NEW DIS",
		headerAlign: "center",
		flex: 0.8,
		minWidth: 80,
		renderCell: ({ row }) => <DiscountRenderCell type="NEW" value={row.new_dis} row={row} />,
	},
	{
		field: "ltl_opt",
		headerName: "PRV OPTIONS",
		flex: 0.85,
		minWidth: 80,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_opt} row={row} font={normalFont} />,
	},
	{
		field: "new_opt",
		headerName: "NEW OPTIONS",
		flex: 0.9,
		minWidth: 85,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.new_opt} row={row} font={normalFont} />,
	},
	{
		field: "ltl_st",
		headerName: "PRV ST",
		flex: 0.8,
		minWidth: 75,
		headerAlign: "center",
		renderCell: ({ row }) => <DiscountRenderCell type="OLD" row={row} value={row.ltl_st} />,
	},
	{
		field: "ltl_inventory_qty",
		headerName: "PRV DISP",
		flex: 0.9,
		minWidth: 85,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_inventory_qty} row={row} font={normalFont} />,
	},
	{
		field: "ltl_asp",
		headerName: "PRV ASP",
		flex: 0.85,
		minWidth: 80,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_asp} row={row} font={normalFont} />,
	},
	{
		field: "new_asp",
		headerName: "NEW ASP",
		flex: 0.85,
		minWidth: 80,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.new_asp} row={row} font={normalFont} />,
	},
	{
		field: "ltl_nsv",
		headerName: "PRV NSV",
		flex: 1,
		minWidth: 90,
		headerAlign: "center",
		renderCell: ({ row }) => <TableInLakhsDisplay value={row.ltl_nsv} row={row} />,
	},
	{
		field: "new_nsv",
		headerName: "NEW NSV",
		flex: 1,
		minWidth: 90,
		headerAlign: "center",
		renderCell: ({ row }) => <TableInLakhsDisplay value={row.new_nsv} row={row} />,
	},
];

export const buildSubcategoryColumns = (ltlCount, newCount) => [
	{
		field: "sub_category",
		width: 140,
		headerAlign: "center",
		headerName: "Sub Category",
		renderCell: ({ row }) => <DefRenderCell value={row.sub_category} row={row} font={normalFont} />,
	},
	{
		field: "ltl_qty",
		headerName: "PRV QTY",
		width: 120,
		headerAlign: "center",
		renderCell: ({ row }) => (
			<QtyWithContribution value={row.ltl_qty} row={row} type="OLD" totalQty={ltlCount} />
		),
	},
	{
		field: "new_qty",
		headerName: "NEW QTY",
		width: 120,
		headerAlign: "center",
		renderCell: ({ row }) => (
			<QtyWithContribution value={row.new_qty} row={row} type="NEW" totalQty={newCount} />
		),
	},
	{
		field: "ltl_dis",
		headerName: "PRV DIS",
		headerAlign: "center",
		width: 80,
		renderCell: ({ row }) => <DiscountRenderCell type="OLD" row={row} value={row.ltl_dis} />,
	},
	{
		field: "new_dis",
		headerName: "NEW DIS",
		headerAlign: "center",
		width: 90,
		renderCell: ({ row }) => <DiscountRenderCell type="NEW" value={row.new_dis} row={row} />,
	},
	{
		field: "ltl_opt",
		headerName: "PRV OPTIONS",
		width: 80,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_opt} row={row} font={normalFont} />,
	},
	{
		field: "new_opt",
		headerName: "NEW OPTIONS",
		width: 90,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.new_opt} row={row} font={normalFont} />,
	},
	{
		field: "ltl_st",
		headerName: "PRV ST",
		width: 80,
		headerAlign: "center",
		renderCell: ({ row }) => <DiscountRenderCell type="OLD" row={row} value={row.ltl_st} />,
	},
	{
		field: "ltl_inventory_qty",
		headerName: "PRV DISP",
		width: 90,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_inventory_qty} row={row} font={normalFont} />,
	},
	{
		field: "ltl_asp",
		headerName: "PRV ASP",
		width: 90,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.ltl_asp} row={row} font={largeFont} />,
	},
	{
		field: "new_asp",
		headerName: "NEW ASP",
		width: 95,
		headerAlign: "center",
		renderCell: ({ row }) => <DefRenderCell value={row.new_asp} row={row} font={normalFont} />,
	},
	{
		field: "ltl_nsv",
		headerName: "PRV NSV",
		width: 100,
		headerAlign: "center",
		renderCell: ({ row }) => <TableInLakhsDisplay value={row.ltl_nsv} row={row} />,
	},
	{
		field: "new_nsv",
		headerName: "NEW NSV",
		width: 110,
		headerAlign: "center",
		renderCell: ({ row }) => <TableInLakhsDisplay value={row.new_nsv} row={row} />,
	},
];
